(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".upload-tab-btn");
  const contents = document.querySelectorAll(".upload-tab-content");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const tabId = button.getAttribute("data-tab");

      contents.forEach(content => {
        content.style.display = content.id === tabId ? "block" : "none";
      });

      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
